import {Component, OnInit} from '@angular/core';
import {ScheduleService} from '../../../services/schedule.service';
import {Show} from '../../../services/schedule.model';

@Component({
  selector: 'psr-livestream-current-show',
  templateUrl: './livestream-current-show.component.html',
  styleUrls: ['./livestream-current-show.component.scss']
})
export class LivestreamCurrentShowComponent implements OnInit {

  public currentShow: Show;
  public showDescription = false;

  constructor(private ss: ScheduleService) {
  }

  ngOnInit(): void {
    this.ss.scheduleData.subscribe(data => {
      this.currentShow = data.current;
      if (!!this.currentShow) {
        if (this.currentShow.name.indexOf('<span></span>') === -1) {
          this.currentShow.name += '<span></span>';
        }
      }
    });
  }

  toggleDescription(): void {
    this.showDescription = !this.showDescription;
  }

  parseShowTime(starts: string): string {
    return this.ss.formatTime(starts);
  }
}
